import { AppConstants } from '../shared/app.constants';
import { AuthService } from '../auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
var AvailabiltyService = /** @class */ (function () {
    function AvailabiltyService(appConstants, auth, http) {
        this.appConstants = appConstants;
        this.auth = auth;
        this.http = http;
    }
    AvailabiltyService.prototype.getAvailableDays = function (body) {
        var url = environment.apiBase + 'shifts/days_available/';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    AvailabiltyService.prototype.getAvailableFreelancers = function (body) {
        var url = environment.apiBase + 'bookings/availAdmin';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return AvailabiltyService;
}());
export { AvailabiltyService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/availabilty.service.ts.pre-build-optimizer.js